import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all tblCurrencys
export const getCurrency = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/currency`);
    return response.data;
  } catch (error) {
    console.error("Error fetching currency:", error.response?.data || error);
    throw error;
  }
};

// GET a single tblCurrency
export const getCurrencyById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/currency/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching currency:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new tblCurrency
export const createCurrency = async (tblCurrencyData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/currency`, tblCurrencyData);
    return response.data;
  } catch (error) {
    console.error("Error creating currency:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing tblCurrency
export const updateCurrency = async (id, tblCurrencyData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/currency/${id}`, tblCurrencyData);
    return response.data;
  } catch (error) {
    console.error("Error updating currency:", error.response?.data || error);
    throw error;
  }
};

// DELETE a tblCurrency
export const deleteCurrency = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/currency/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting currency:", error.response?.data || error);
    throw error;
  }
};
